#import "../fragments/user-quota-fragment.graphql"

query GetUsersWithQuotas($first: Int, $after: String, $minFiscalYear: Int!) {
    usersWithQuotas(first: $first, after: $after, minFiscalYear: $minFiscalYear) {
        pageInfo {
            endCursor
            hasNextPage
        }
        edges {
            node {
                ...UserQuotaFragment
            }
        }
    }
}
